/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Agent_Readiness_Check_Error_DocumentationInputs */

const en_directory_agent_readiness_check_error_documentation = /** @type {(inputs: Directory_Agent_Readiness_Check_Error_DocumentationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error documentation`)
};

const zh_directory_agent_readiness_check_error_documentation = /** @type {(inputs: Directory_Agent_Readiness_Check_Error_DocumentationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`错误文档`)
};

/**
* | output |
* | --- |
* | "Error documentation" |
*
* @param {Directory_Agent_Readiness_Check_Error_DocumentationInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_agent_readiness_check_error_documentation = /** @type {((inputs?: Directory_Agent_Readiness_Check_Error_DocumentationInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Agent_Readiness_Check_Error_DocumentationInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_agent_readiness_check_error_documentation(inputs)
	return zh_directory_agent_readiness_check_error_documentation(inputs)
});
export { directory_agent_readiness_check_error_documentation as "directory.agent_readiness.check.error_documentation" }